import { Text } from "./Text";
/**
 * Унифицированное текстовое поле с подписью для форм приложения.
 * У поля пароля справа глазик: показать или скрыть введённое.
 */
import { useState, type ComponentPropsWithoutRef } from "react";
import { Button } from "./Button";
import { IconEye, IconEyeOff } from "./icons";

type TextInputProps = Omit<ComponentPropsWithoutRef<"input">, "onChange"> & {
	label?: string;
	bare?: boolean;
	onChange: (value: string) => void;
};

export const TextInput = ({
	label,
	bare = false,
	className = "",
	type,
	onChange,
	...props
}: TextInputProps) => {
	const [passwordVisible, setPasswordVisible] = useState(false);
	const isPassword = type === "password" && !bare;
	const input = (
		<input
			className={
				bare
					? className
					: `mt-1.5 w-full rounded-lg border border-border bg-surface px-3 py-2.5 text-base outline-none focus:border-accent ${isPassword ? "pr-11" : ""} ${className}`
			}
			type={isPassword && passwordVisible ? "text" : type}
			onChange={(event) => onChange(event.target.value)}
			{...props}
		/>
	);

	if (bare) return input;
	return (
		<label className="block text-sm font-medium">
			{label && <Text as="span">{label}</Text>}
			{isPassword ? (
				<div className="relative">
					{input}
					<Button
						border={false}
						className="absolute top-1.5 right-1 bottom-0 flex items-center px-2.5 text-ink hover:bg-transparent hover:text-accent"
						aria-label={passwordVisible ? "Скрыть пароль" : "Показать пароль"}
						title={passwordVisible ? "Скрыть пароль" : "Показать пароль"}
						aria-pressed={passwordVisible}
						onClick={() => setPasswordVisible(!passwordVisible)}
					>
						{passwordVisible ? <IconEyeOff /> : <IconEye />}
					</Button>
				</div>
			) : (
				input
			)}
		</label>
	);
};
